import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { CompanyService } from 'app/company/services/company.service';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AuditListModel } from 'app/audit/models/audit-list.model';
import { AuditService } from 'app/audit/services/audit.service';

@Component({
    selector: 'app-add-company-audit',
    templateUrl: './add-company-audit.component.html',
    styleUrls: ['./add-company-audit.component.css']
})
export class AddCompanyAuditComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    companies: CompanyListModel[];
    submitAttempt: boolean = false;
    addCompanyAuditFormGroup: FormGroup;
    companyId: string;
    audits: AuditListModel[];

    constructor(
        private companyService: CompanyService,
        private fb: FormBuilder,
        private location: Location,
        private router: Router,
        private auditService: AuditService,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.companyId = this.activatedRoute.snapshot.params['id'];
        this.headerTitle = {
            title: 'Add Audit',
            breadcrumbs: [{ title: 'Company Audits', url: ['/company/audits', this.companyId] }]
        };

        this.getAudits();
        this.initializeForm();
    }

    initializeForm(): void {
        this.addCompanyAuditFormGroup = this.fb.group(
            {
                title: ['', Validators.required],
                auditId: [''],
                companyId: [this.companyId],
                startDate: ['', Validators.required],
                endDate: ['']
            }
        );
    }

    getAudits(): void {
        this.auditService.getAll().subscribe(
            audits => {
                this.audits = audits;
            },
            error => this.errors = error.errorList
        );
    }

    addCompanyAudit(): void {
        this.submitAttempt = true;

        var startDate = this.addCompanyAuditFormGroup.get('startDate').value;
        var endDate = this.addCompanyAuditFormGroup.get('endDate').value;        

        if (this.addCompanyAuditFormGroup.valid) {
            const formValue = this.addCompanyAuditFormGroup.value;

            formValue.startDate = startDate ? new Date(new Date(startDate).setHours(12)).toISOString() : null;
            formValue.endDate = endDate ? new Date(new Date(endDate).setHours(12)).toISOString() : null;

            this.companyService.createCompanyAudit(formValue).subscribe(
                companyId => {
                    this.router.navigate(['./company/audits', this.companyId]);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }
}
